/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconInnerShadowBottomLeft = createReactComponent("outline", "inner-shadow-bottom-left", "IconInnerShadowBottomLeft", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M6 12a6 6 0 0 0 6 6", "key": "svg-1" }]]);

export { IconInnerShadowBottomLeft as default };
//# sourceMappingURL=IconInnerShadowBottomLeft.mjs.map
